import { cn } from "@spz/ui/lib/utils";
import tailwindConfig from "@spz/ui/tailwind-config";
import { Icon, type IconSymbol } from "./icon";
import { Typography } from "./typography";

interface HintProps {
  text: string;
  horizontal?: boolean;
  className?: string;
  variant?: "info" | "warning" | "alert" | "success";
}

const variantConfig = {
  info: {
    icon: "info" as IconSymbol,
    bgClass: "bg-blue-50",
    iconColor: tailwindConfig.theme.colors.blue[500],
  },
  warning: {
    icon: "triangle-alert" as IconSymbol,
    bgClass: "bg-orange-50",
    iconColor: tailwindConfig.theme.colors.orange[500],
  },
  alert: {
    icon: "octagon-x" as IconSymbol,
    bgClass: "bg-red-50",
    iconColor: tailwindConfig.theme.colors.red[500],
  },
  success: {
    icon: "circle-check" as IconSymbol,
    bgClass: "bg-green-50",
    iconColor: tailwindConfig.theme.colors.green[500],
  },
};

export const Hint: React.FC<HintProps> = ({
  text,
  horizontal = true,
  variant = "info",
  className,
}) => {
  const config = variantConfig[variant];

  return (
    <div
      className={cn(
        "flex items-center gap-2",
        horizontal ? "flex-row" : "flex-col",
        className,
      )}
    >
      <div
        className={cn(
          "w-5.5 h-5.5 flex items-center justify-center rounded",
          config.bgClass,
        )}
      >
        <Icon
          icon={config.icon}
          size={14}
          className="flex-shrink-0"
          color={config.iconColor}
        />
      </div>
      <Typography className="text-start font-poppins font-semibold text-blue-900">
        {text}
      </Typography>
    </div>
  );
};
